import {
  fetchAll,
  fetchFiltered,
  fetchVerifySerial,
  addOs,
  fetchCheckContractAndBoard,
  fetchAllPageOsSWForm,
  fetchVehicleData,
  fetchVehiclesToReuse
} from '@/api/ossw'
import { t } from '@/lib/i18n'

const state = {
  all        : [],
  isLoading  : false,
  vehicleData: {},
  vehiclesToReuse: []
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const os = await fetchAll()
      commit('setAll', os)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const os = await fetchFiltered(queriesParams)
        commit('setAll', os)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchSaveTestDate({ dispatch, commit }, date) {
    return commit('setTestDate', date)
  },

  async fetchVerifySerial({ dispatch, commit }, serial) {

    try {
      const isLocadados = await fetchVerifySerial(serial)

      return !isLocadados.CLI_ID
        ? 'notFound'
        : { cli_id: isLocadados.CLI_ID, vei_fld: isLocadados.VEI_FLD }
      
    } catch (error) {
      dispatch('notify/error', { message: t(error.message) }, { root: true })

      return 'error'
    }

  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    dispatch('overlay/show', true, { root: true })

    try {
      await addOs(data)

      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })
    } finally {
      commit('setLoading', false)
      dispatch('overlay/show', false, { root: true })
    }

    return false
  },

  async fetchCheckContractAndBoard ({ dispatch, commit }, data) {
    try {
      await fetchCheckContractAndBoard(data)
      return true
    } catch (error) {
      return false
    }
  },

  async fetchAllPageOsSWList ({ dispatch, commit }) {
    try {
      const all = await fetchAllPageOsSWForm()
      commit('setAll', all)
    } catch (error) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAllPageOsSWForm ({ dispatch, commit }) {
    try {
      const all = await fetchAllPageOsSWForm()
      commit('setAll', all)
    } catch (error) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVehicleData ({ dispatch, commit }, params) {
    commit('setVehicleData', {})

    try {
      const data = await fetchVehicleData(params)
      commit('setVehicleData', data)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchVehiclesToReuse ({ dispatch, commit }, params) {
    commit('setVehiclesToReuse', [])

    try {
      const { rows } = await fetchVehiclesToReuse(params)
      commit('setVehiclesToReuse', rows)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.all       = []
    state.isLoading = false
    state.vehicleData = {}
    state.vehiclesToReuse = []
  },

  setAll (state, os) {
    state.all = os
  },

  setTestDate(state, date) {
    state.osById.testDate = date
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  setVehicleData(state, data) {
    state.vehicleData = data
  },

  setVehiclesToReuse(state, data) {
    state.vehiclesToReuse = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
